exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.summary-card[data-v-06a459bd] {\n  margin-bottom: 15px;\n  text-align: center;\n}\n.summary-card .heading[data-v-06a459bd] {\n    font-weight: bold;\n}\n.summary-card .number[data-v-06a459bd] {\n    font-size: 2rem;\n    font-weight: bold;\n    color: #b29b81;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-06a459bd","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/elements/SummaryCard.vue
// module id = 542
// module chunks = 0